import { AxiosError } from "axios";

import { CartItem } from "custom-types/Cart";

type ErrorMetaData = {
  cartItems?: Partial<CartItem>;
  reason?: string;
  readableMessage?: string;
};

export class ReservationsApiError extends Error {
  title: string;
  detail: string;
  // metadata is provided for: Axios errors, ReservationsApi::Internal errors
  // and ReservationsApi::External errors.
  metadata: ErrorMetaData | null;
  reason: string | null;
  readableMessage: string;
  constructor({
    message = "There was an error while placing the order",
    metadata = null,
    title = "",
    detail = "",
  }) {
    super(message);
    this.title = title;
    this.detail = detail;
    this.metadata = metadata;
    // The reason should now exist in the metadata as metadata.reason for all
    // errors, but for legacy support, pulling the reason from the error detail
    // will be left in place.
    this.reason =
      (metadata as ErrorMetaData | null)?.reason ||
      detail
        ?.split(" ")
        .find((s) => s.includes("reason="))
        ?.replace("reason=", "") ||
      null;
    // metadata.readableMessage includes consumer facing message to be displayed
    // to the consumer for a given error.
    this.readableMessage = (metadata as ErrorMetaData | null)
      ?.readableMessage as string;
  }
}

export class ApiOgServiceError extends Error {
  url: string | undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  status: any;
  constructor(axiosResponse: AxiosError, message: string) {
    const { config: { url } = {}, response: { status, statusText } = {} } =
      axiosResponse;

    super(message || statusText);
    this.url = url;
    this.status = status || 500;
  }
}

export class ComplianceServiceError extends Error {
  url: string | undefined;
  status: number;
  constructor(axiosResponse: AxiosError, message: string) {
    const { config: { url } = {}, response: { status, statusText } = {} } =
      axiosResponse;

    super(message || statusText);
    this.url = url;
    this.status = status || 500;
  }
}
